<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header widget-title">{{widgetData?.title}}</div>
    <div class="low-battery-count">
        <div class="d-flex align-items-center justify-content-center">
            <div class="count-value">1 hr 30 min</div>
        </div>
    </div>
</div>
